export default __webpack_public_path__ + "static/media/new-patient-1.b5828dc4.png";